export default {
  quotes: null,
  quote: null,
  error: false,
  errorMessage: "",
  successMessage: "",
  success: false,
};
